import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import InfoRounded from '@mui/icons-material/InfoRounded';
import { Stack, TableCell, Tooltip } from '@mui/material';
import type { TFunction } from 'i18next';

import { ReportOrderStatus, ReportStatus } from 'src/constants/report';
import type { Report } from 'src/types/report';
import useSurveySettings from 'src/hooks/useSurveySettings';
import {
  formatDateString,
  getOrderStatus,
  getReportStatus,
} from 'src/helper/helper';

interface CustomReportsTableCellsProps {
  report: Report;
  t: TFunction;
}

const CustomReportsTableCells: FC<CustomReportsTableCellsProps> = ({
  report,
}) => {
  const { t } = useTranslation('report');
  const { minRespondentAmount } = useSurveySettings();

  return (
    <>
      <TableCell align="center">
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <span>
            {t(`reportStatus.${getOrderStatus(report.order_status)}`)}
          </span>

          {report.order_status === ReportOrderStatus.ERROR &&
            report.status !== ReportStatus.AVAILABLE && (
              <Tooltip
                title={
                  report.status
                    ? t(`reportStatus.${getReportStatus(report.status)}`, {
                        minRespondentAmount,
                      })
                    : // Show this error message in case there is no matching report status provided.
                      t('tooFewRespondents', { minRespondentAmount })
                }
              >
                <InfoRounded fontSize="small" />
              </Tooltip>
            )}
        </Stack>
      </TableCell>

      <TableCell align="center">
        {report.last_modified ? formatDateString(report.last_modified) : '-'}
      </TableCell>

      <TableCell align="center">
        {report.created_by
          ? `${report.created_by.first_name || '-'}  ${
              report.created_by.last_name || '-'
            }`
          : '-'}
      </TableCell>

      <TableCell align="center">
        {report.shared_by
          ? `${report.shared_by.first_name || '-'}  ${
              report.shared_by.last_name || '-'
            }`
          : '-'}
      </TableCell>
    </>
  );
};

export default CustomReportsTableCells;
